const chunkMapping = {
	"852": [
		852
	],
	"1683": [
		1683
	],
	"1786": [
		71786
	],
	"3943": [
		53943
	],
	"4800": [
		14800
	],
	"5512": [
		75512
	],
	"5673": [
		85673
	],
	"6374": [
		86374
	],
	"8581": [
		28581
	],
	"9333": [
		19333
	]
};
const idToExternalAndNameMapping = {
	"852": [
		"default",
		"./source",
		3664
	],
	"1683": [
		"default",
		"./AgSubscriptionSModule",
		74284
	],
	"14800": [
		"default",
		"./source",
		73678
	],
	"19333": [
		"default",
		"./AgNavigationBarMobileSModule",
		74284
	],
	"28581": [
		"default",
		"./AgCoreSModule",
		74284
	],
	"53943": [
		"default",
		"./AgHeaderSModule",
		74284
	],
	"71786": [
		"default",
		"./AgSettingsAggregatorSModule",
		74284
	],
	"75512": [
		"default",
		"./source",
		74284
	],
	"85673": [
		"default",
		"./AgTabStripSModule",
		74284
	],
	"86374": [
		"default",
		"./source",
		92035
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			let getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			const data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			const onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			const handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					const promise = fn(arg1, arg2);
					if(promise?.then) {
						const p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			const onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			const onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			const onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}